import { render, staticRenderFns } from "./ProductTable.vue?vue&type=template&id=911b549a"
import script from "./ProductTable.vue?vue&type=script&lang=ts"
export * from "./ProductTable.vue?vue&type=script&lang=ts"
import style0 from "./ProductTable.vue?vue&type=style&index=0&id=911b549a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports